import React from "react";

function Advertisement({ src, alt, linkAttributes }) {
  return (
    <div className="advertisement surface--light-cream-2 p-2">
      <p className="ad-heading"> Advertisement </p>
      <div className={`ratio ratio-6x5`}>
        { linkAttributes && <a {...linkAttributes} > {alt} </a> }
        <img src={src} alt={alt} loading='lazy' />
      </div>
    </div>
  );
}

export default Advertisement;